import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AbstractWS {
  constructor(private http: HttpClient) { }

  private getHeaders(token: string): Promise<HttpHeaders> {
    return new Promise(resolve => {
      let headers = new HttpHeaders();
      if (token) {
        headers.append('Authorization', 'Token ' + token);
      }
      headers.append('Accept', 'application/json');
      headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Access-Control-Allow-Headers', 'Content-Type');
      headers.append('Content-Type', "application/x-www-form-urlencoded");
      resolve(headers);
    });
  }

  private getHeadersRaw(token?: string): Promise<HttpHeaders> {
    return new Promise(resolve => {
      let headers = new HttpHeaders();
      if (token) {
        headers.append('Authorization', 'Token ' + token);
      }
      headers.append('Accept', 'application/json');
      headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Access-Control-Allow-Headers', 'Content-Type');
      headers.append("Content-Type", "application/json");
      resolve(headers);
    });
  }

  private getHeadersJson(token: string): Promise<HttpHeaders> {
    return new Promise(resolve => {
      let headers = new HttpHeaders();
      if (token) {
        headers.append('Authorization', 'Token ' + token);
      }
      headers.append('Accept', 'application/json');
      headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Access-Control-Allow-Headers', 'Content-Type');
      headers.delete("Content-Type")
      headers.append("Content-Type", "application/json");
      resolve(headers);
    });
  }

  private getHeadersMultipart(token: string): Promise<HttpHeaders> {
    return new Promise(resolve => {
      let headers = new HttpHeaders();
      if (token) {
        headers.append('Authorization', 'Token ' + token);
      }
      headers.append('Accept', 'application/json');
      headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Access-Control-Allow-Headers', 'Content-Type');
      headers.delete("Content-Type")
      headers.append('Content-Type', 'multipart/form-data');
      resolve(headers);
    });
  }

  protected makeGetRequest(path: string, paramsRequest: any, token?: string): Promise<any> {
    if (!paramsRequest) {
      paramsRequest = {};
    }
    return this.getHeaders(token).then(headers => {
      return new Promise((resolve, reject) => {
        this.http.get(path, { headers: headers, params: paramsRequest }).toPromise().then(response => {
            resolve(response);
          }).catch(err => {
            if (err.status === 200) {
              resolve(null);
            } else {
              //console.log(err);
              reject(err);
            }
          });
      });
    });
  }

  protected makePostRequestWithoutHeaders(path: string, data: any): Promise<any> {
    let headers = new HttpHeaders().set('Accept', 'application/json');
    return this.http.post(path, data, { headers: headers }).toPromise().then((response: HttpResponse<any>) => {
        return Promise.resolve(response);
      }).catch(function (error) {
        return Promise.reject(null);
      });
  }

  protected makePostRequest(path: string, data: any, token?: string): Promise<any> {
    return this.getHeaders(token).then(headers => {
      return this.http.post(path, data, { headers: headers }).toPromise().then((response: HttpResponse<any>) => {
          return Promise.resolve(response);
        }).catch(function (error) {
          return Promise.reject(null);
        });
    });
  }

  protected makeDeleteRequest(path: string, paramsRequest: any, token?: string): Promise<any> {
    return this.getHeaders(token).then(headers => {
      return this.http.delete(path, { headers: headers, params: paramsRequest }).toPromise().then((response: HttpResponse<any>) => {
          return Promise.resolve(response);
        }).catch(function (error) {
          return Promise.reject(null);
        });
    });
  }

  protected makePostRequestRaw(path: string, data: any, token?: string): Promise<any> {
    return this.getHeadersRaw(token).then(headers => {
      return this.http.post(path, data, { headers: headers }).toPromise().then((response: HttpResponse<any>) => {
        return Promise.resolve(response);
      }).catch(function (error) {
        return Promise.reject(null);
      });
    });
  }

  protected makePostRequestJson(path: string, data: any, token?: string): Promise<any> {
    return this.getHeadersJson(token).then(headers => {
      return this.http.post(path, data, { headers: headers }).toPromise().then((response: HttpResponse<any>) => {
          return Promise.resolve(response);
        }).catch(function (error) {
          return Promise.reject(null);
        });
    });
  }

  protected makePostRequestMultipart(path: string, formData: any, token?: string): Promise<any> {
    return this.getHeadersMultipart(token).then(headers => {
      return this.http.post(path, formData, { headers: headers }).toPromise().then((response: HttpResponse<any>) => {
          return Promise.resolve(response);
        }).catch(function (error) {
          return Promise.reject(null);
        });
    });
  }
}
